import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../../utils/Functions';

const WindowModel = ({ windowWidth, windowHeight, marginY, doorColor, glassTexture }) => {
    const deviation = 0.1;
    const railThickness = 0.01
    const distanceX = windowWidth / 3;
    const distanceY = windowHeight / 3;
    
    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, -windowHeight / 2);
        model.quadraticCurveTo(
                -windowWidth / 2.5, windowHeight / 2,
                0, windowHeight / 2
            );
        model.quadraticCurveTo(
                windowWidth / 2.5, windowHeight / 2,
                windowWidth / 2, -windowHeight / 2
            );
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo((windowWidth / 2 - deviation), -(windowHeight / 2 - deviation));
        hole.quadraticCurveTo(
                (windowWidth / 2.5 - deviation), (windowHeight / 2 - deviation),
                0, (windowHeight / 2 - deviation)
            );
        hole.quadraticCurveTo(
                -(windowWidth / 2.5 - deviation), (windowHeight / 2 - deviation),
                -(windowWidth / 2 - deviation), -(windowHeight / 2 - deviation)
            );
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [windowHeight, windowWidth])

    const windowRailModel = useMemo(() => {
        let model = [];
        
        const rail_round = new THREE.Shape();
        rail_round.moveTo(-(distanceX / 2 + railThickness), -windowHeight / 2);
        rail_round.quadraticCurveTo(
                -(distanceX / 2.5 + railThickness), -(windowHeight / 2) / 4,
                0, -(windowHeight / 2) / 4
            )
        rail_round.quadraticCurveTo(
                (distanceX / 2.5 + railThickness), -(windowHeight / 2) / 4,
                (distanceX / 2 + railThickness), -windowHeight / 2
            )
        rail_round.closePath();

        const rail_round_hole = new THREE.Path();
        rail_round_hole.moveTo((distanceX / 2), -windowHeight / 2);
        rail_round_hole.quadraticCurveTo(
                (distanceX / 2.5), -(windowHeight / 2) / 4,
                0, -(windowHeight / 2) / 4
            )
            rail_round_hole.quadraticCurveTo(
                -(distanceX / 2.5), -(windowHeight / 2) / 4,
                -(distanceX / 2), -windowHeight / 2
            )
        rail_round_hole.closePath();

        rail_round.holes.push(rail_round_hole);

        const rail_mid = new THREE.Shape();
        rail_mid.moveTo(-railThickness / 2, -(windowHeight / 2) / 4);
        rail_mid.lineTo(-railThickness / 2, windowHeight / 2);
        rail_mid.lineTo(railThickness / 2, windowHeight / 2);
        rail_mid.lineTo(railThickness / 2, -(windowHeight / 2) / 4);
        rail_mid.closePath();

        const rail_left = new THREE.Shape();
        rail_left.moveTo(-windowWidth / 2, windowHeight / 2 - railThickness / 2);
        rail_left.lineTo(-windowWidth / 2, windowHeight / 2 + railThickness / 2);
        rail_left.lineTo(-distanceX / 2 * (2.3 / 4), -(windowHeight / 8) - ((windowHeight / 8) * (1 / 2)) + railThickness / 2);
        rail_left.lineTo(-distanceX / 2 * (2.5 / 4), -(windowHeight / 8) - ((windowHeight / 8) * (1 / 2)) - railThickness / 2);
        rail_left.closePath();

        const rail_right = new THREE.Shape();
        rail_right.moveTo(windowWidth / 2, windowHeight / 2 - railThickness / 2);
        rail_right.lineTo(windowWidth / 2, windowHeight / 2 + railThickness / 2);
        rail_right.lineTo(distanceX / 2 * (2.3 / 4), -(windowHeight / 8) - ((windowHeight / 8) * (1 / 2)) + railThickness / 2);
        rail_right.lineTo(distanceX / 2 * (2.5 / 4), -(windowHeight / 8) - ((windowHeight / 8) * (1 / 2)) - railThickness / 2);
        rail_right.closePath();

        model.push(rail_round);
        model.push(rail_mid);
        model.push(rail_left);
        model.push(rail_right);

        return model;

    
    }, [windowHeight, windowWidth])

    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, -windowHeight / 2);
        model.quadraticCurveTo(
                -windowWidth / 2.5, windowHeight / 2,
                0, windowHeight / 2
            );
        model.quadraticCurveTo(
                windowWidth / 2.5, windowHeight / 2,
                windowWidth / 2, -windowHeight / 2
            );
        model.closePath();

        return model;
    }, [windowWidth, windowHeight])
    
    return (
        <group>
            <group name='window'>
                <mesh name='glass-window-trim' position={[0, 0, 0.06]}>
                    <extrudeGeometry args={[trimModel, extrudeSettings(0.15, 0.03, 0.03, 0, 2)]} />
                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} />
                </mesh>
                <mesh name='glass-window-rail' position={[0, 0, 0.06]}>
                    <extrudeGeometry args={[windowRailModel, extrudeSettings(0.15, 0.02, 0.03, 0, 2)]} />
                    <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.3} />
                </mesh>
                <mesh name='glass' position={[0, 0, 0.055]}>
                    <extrudeGeometry args={[glassModel, extrudeSettings(0.15)]} />
                    <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
                </mesh>
            </group>
        </group>
    )
}

export default WindowModel